import { ApplicationRef, Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { registerLocaleData } from '@angular/common';
import ru from '@angular/common/locales/ru';
import en from '@angular/common/locales/en-GB';
import { Observable, ReplaySubject } from 'rxjs';
import { UiConfigService } from './ui-config.service';
import { WINDOW } from '../tokens/window';
import { BROWSER_LOCALE } from '../utils/constants';

export enum Locale {
  RU = 'ru',
  EN_GB = 'en-gb',
}

@Injectable({
  providedIn: 'root',
})
export class LocalizationService {
  locale$: Observable<Locale>;

  private localeSubject: ReplaySubject<Locale>;

  private browserLocale: Locale;

  constructor(
    private translateService: TranslateService,
    private dateAdapter: DateAdapter<any>,
    private uiConfigService: UiConfigService,
    private ref: ApplicationRef,
    @Inject(WINDOW) private window: Window,
  ) {
    // Load locale data for angular pipes
    registerLocaleData(ru);
    registerLocaleData(en);
    this.localeSubject = new ReplaySubject<Locale>(1);
    this.locale$ = this.localeSubject.asObservable();
    const browserLocaleString = window.navigator.language;
    let browserLocale: Locale | null = null;
    for (const locale of Object.values(Locale)) {
      if (locale === browserLocaleString) {
        browserLocale = locale;
      }
    }
    if (browserLocale == null) {
      browserLocale = Locale.EN_GB;
    }
    this.browserLocale = browserLocale;
    console.log('Browser locale', browserLocale);
    this.setLocale(browserLocale);
    this.uiConfigService.uiConfig$.subscribe((uiConfig) => {
      if (uiConfig != null) {
        const locale = uiConfig.personalization.locale;
        console.log('New locale', locale);
        if (locale === BROWSER_LOCALE) {
          this.setLocale(this.browserLocale);
        } else {
          this.setLocale(locale);
        }
      }
    });
  }

  setLocale(locale: Locale): void {
    this.dateAdapter.setLocale(locale);
    this.translateService.use(locale);
    this.localeSubject.next(locale);
    this.ref.tick();
  }
}
